module.exports = __webpack_public_path__ + "static/media/left-kneecap-up.0596a2fd.png";